import React from "react";

const WHATSAPP_NUMBER = "917737671164"; // E.164 without '+'
const PREFILLED_MESSAGE =
  "Hi Gralon Global, I'd like to inquire about your products.";

const WhatsAppButton = () => {
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    PREFILLED_MESSAGE
  )}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      aria-label="Chat with Gralon Global on WhatsApp"
      className="group fixed left-5 bottom-5 sm:left-6 sm:bottom-6 z-[60] flex items-center"
    >
      {/* Pulsing ring */}
      <span className="absolute inline-flex h-14 w-14 rounded-full bg-[#25D366] opacity-60 animate-ping" />

      {/* Tooltip */}
      <span className="absolute left-16 whitespace-nowrap bg-forest-deep text-cream text-xs tracking-[0.2em] uppercase px-4 py-2 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 pointer-events-none">
        Chat on WhatsApp
      </span>

      {/* Button */}
      <span className="relative inline-flex items-center justify-center h-14 w-14 rounded-full bg-[#25D366] text-white shadow-lg shadow-black/20 ring-2 ring-white/40 hover:bg-[#1ebe5b] transition-colors duration-300">
        {/* WhatsApp glyph */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          className="h-7 w-7 fill-current"
          aria-hidden="true"
        >
          <path d="M19.077 4.928a9.94 9.94 0 0 0-7.05-2.928c-5.523 0-10 4.477-10 10 0 1.762.46 3.479 1.336 5.003L2 22l5.193-1.337A9.99 9.99 0 0 0 12.027 22h.004C17.55 22 22 17.523 22 12c0-2.668-1.04-5.179-2.923-7.072ZM12.03 20.27h-.004a8.27 8.27 0 0 1-4.215-1.155l-.302-.18-3.082.793.823-3.005-.197-.31A8.27 8.27 0 0 1 3.73 12c0-4.566 3.715-8.281 8.292-8.281 2.214 0 4.293.864 5.86 2.43A8.218 8.218 0 0 1 20.32 12c0 4.566-3.717 8.27-8.29 8.27Zm4.55-6.197c-.249-.125-1.475-.728-1.703-.81-.228-.083-.394-.124-.56.124-.165.249-.642.81-.787.974-.145.166-.29.187-.539.062-.249-.124-1.052-.388-2.005-1.237-.741-.661-1.241-1.479-1.387-1.728-.144-.249-.015-.383.11-.508.113-.112.249-.291.374-.436.124-.145.166-.249.249-.415.083-.166.041-.31-.021-.435-.062-.124-.56-1.353-.768-1.853-.202-.486-.408-.42-.56-.428l-.477-.008c-.166 0-.435.062-.663.31-.228.249-.87.85-.87 2.072 0 1.222.892 2.404 1.016 2.57.124.165 1.755 2.683 4.252 3.762.594.257 1.058.41 1.42.524.596.19 1.139.163 1.568.099.479-.072 1.475-.603 1.683-1.185.207-.583.207-1.083.145-1.185-.062-.103-.228-.166-.477-.29Z" />
        </svg>
      </span>
    </a>
  );
};

export default WhatsAppButton;
